module.exports = __webpack_public_path__ + "static/media/btn_edit_left.e715050b.svg";